import React from 'react';
import styled from 'styled-components';
import RequestsHotelsCardTitle from './RequestsHotelsCardTitle.jsx';
import Card from '../../common/cards/Card.jsx';
import BadgeStatus from '../../common/badges/BadgeStatus.jsx';
import RequestsHotelsInfos from '../../common/requests_hotels/RequestsHotelsInfos';

const Wrapper = styled.div`
	a {
		transition: .3s;

		&:hover {
			text-decoration: none;
            opacity: .6;
		}
	}
`

export default class RequestsHotelsCardSimple extends React.Component {
    constructor(props) {
      super(props);
    }
  
    render(props) {
		const { 
			id, 
			img, 
			accommodation,
			hotel,
			refRequest,
			refHotel,
			refCustomer,
			title, 
			manager,
			budget,
			requestsDate,
			checkin,
			checkout,
			type,
			segment,
			lastViews,
			societe,
			requests,
			connectivityInfos,
			withoutAccommodation,
			status,
			showTitle,
			showManager,
			showBudget,
			badgeBgColor,
			echeancier,
			totalPayed,
			totalHt,
			devise,
			badge,
			frameworkAgreement,
			commission
		} = this.props

		/* Bidouille à Jacky pour avoir une prop compatible avec le composant typescript */
		const requestHotelInfosProp = {
			id: id,
			request: {
				id: requests.id,
				refClient: refCustomer,
				dateCreated: requests.timestamp,
				source: requests.source,
				societe: {
					id: requests.societes_id
				},
				requestClassicData: {
					nbPaxTotal: accommodation ? 1 : 0
				},
				formRequest: {
					name: requests.forms_requests_name
				},
				frameworkAgreement: frameworkAgreement
			},
			hotel: {
				title: hotel
			},
			connectivityInfos: connectivityInfos,
			commissionStatus: {slug: commission?.status },
			commissionRate: commission?.rate,
			nbVueUser: lastViews?.client?.nb,
			vuUser: lastViews?.client?.last,
			nbVueHotelier: lastViews?.hotelier?.nb,
			vuHotelier: lastViews?.hotelier?.last
		}

      	return (
			<Wrapper className="col-12 mb-3">
				<a 
					href="#"
					data-part="+"
					data-target={`providers//requests_hotels/details/${id}`}
					className="js-nav get_part_link"
				>
					<Card backgroundImg={img.url}>
						<div className="card-header border-none text-gc-dark-blue bg-transparent p-0">
							<div className="row">
								<div className="col-12 d-flex justify-content-between align-items-center">
									<RequestsHotelsCardTitle 
										id={id}
										title={title} 
										refHotel={refHotel} 
										requestsDate={requestsDate} 
										checkin={checkin} 
										checkout={checkout}
										manager={manager}
										budget={budget}
										showTitle={showTitle}
										showManager={showManager}
										showBudget={showBudget}
										badgeBgColor={badgeBgColor}
										status={status}
										echeancier={echeancier}
										totalPayed={totalPayed}
										totalHt={totalHt}
										devise={devise}
										noLink={true}
									/>
									<BadgeStatus badge={badge} />
								</div>
								<div className="col-12 mt-2">
									<RequestsHotelsInfos
										requestHotel={requestHotelInfosProp}
										canManage={false}
									/>	
								</div>
							</div>
						</div>
					</Card>
				</a>
			</Wrapper>
      	);
    }
}